export default "__VITE_ASSET__845c83e3__"